import { render } from "./Step1.vue?vue&type=template&id=5140b87c&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"

import "./Step1.vue?vue&type=style&index=0&id=5140b87c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5140b87c"]])

export default __exports__